export default __webpack_public_path__ + "static/media/6.d11d3804.png";